import React from 'react';
import Button from 'react-bootstrap/Button';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';

interface DocumentWizardHeaderDownloadSignedPDFButtonProps {
  onClick: () => void;
}

const DocumentWizardHeaderDownloadSignedPDFButton = ({
  onClick,
}: DocumentWizardHeaderDownloadSignedPDFButtonProps) => (
  <Button onClick={onClick} variant="primary" className="document-wizard-header__download-button">
    <TitleFormattedMessage
      id="document-wizard-header.action.download"
      defaultMessage="Download"
      data-testid="document-wizard-header-download-action"
    />
  </Button>
);

export default DocumentWizardHeaderDownloadSignedPDFButton;
